import * as admin from '../actions/admin'
import { getApiErrorMessage } from '../utils/errorUtilities'

const initialState = {
  user: null,
  timeLines: null,
  chargeForecast: null,
  isLoading: false,
  errors: {},
  utilityEligibility: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case admin.ELIGIBILITY_ADMIN_SUCCESS:
      return {
        ...state,
        utilityEligibility: action.payload,
        isLoading: false,
        errors: {},
      }
    case admin.PROGRAM_PARTICIPATION_ADMIN_SUCCESS:
      return {
        ...state,
        programParticipation: action.payload,
        isLoading: false,
        errors: {},
      }
    case admin.PROGRAM_VISIBILITY_ADMIN_SUCCESS:
      return {
        ...state,
        programVisibility: action.payload,
        isLoading: false,
        errors: {},
      }
    case admin.DEVICE_LOAD_GROUPS_ADMIN_SUCCESS:
      return {
        ...state,
        deviceLoadGroups: action.payload,
        isLoading: false,
        errors: {},
      }
    case admin.PROGRAM_LOAD_GROUPS_ADMIN_SUCCESS:
      return {
        ...state,
        programLoadGroups: action.payload,
        isLoading: false,
        errors: {},
      }
    case admin.PROGRAM_REQUIREMENTS_ADMIN_SUCCESS:
      return {
        ...state,
        programRequirements: action.payload,
        isLoading: false,
        errors: {},
      }
    case admin.ALL_PROGRAM_REQUIREMENTS_ADMIN_SUCCESS:
      return {
        ...state,
        allProgramRequirements: action.payload,
        isLoading: false,
        errors: {},
      }
    case admin.CHARGE_FORECAST_ADMIN_SUCCESS:
      return {
        ...state,
        chargeForecast: action.payload,
        isLoading: false,
        errors: {},
      }
    case admin.VEHICLE_TIMELINE_SUCCESS:
      return {
        ...state,
        timeLines: action.payload,
        isLoading: false,
        errors: {},
      }
    case admin.USER_PLAN_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: {},
      }
    case admin.ADMIN_USER_INFORMATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: action.payload,
        errors: {},
      }
    case admin.ADMIN_USER_CHARGER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        chargers: action.payload,
        errors: {},
      }
    case admin.ADMIN_USER_THERMOSTAT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        thermostats: action.payload,
        errors: {},
      }
    case admin.ADMIN_USER_METER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        meters: action.payload,
        errors: {},
      }
    case admin.ADMIN_USER_ENERGY_SYSTEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        energySystems: action.payload,
        errors: {},
      }
    case admin.ADMIN_USER_VEHICLE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        vehicles: action.payload,
        errors: {},
      }
    case admin.PROGRAM_ENROLLMENTS_ADMIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        programEnrollments: action.payload,
        errors: {},
      }
    case admin.REWARD_PAYMENTS_ADMIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        rewardPayments: action.payload,
        errors: {},
      }
    case admin.ELIGIBILITY_ADMIN_REQUEST:
    case admin.PROGRAM_PARTICIPATION_ADMIN_REQUEST:
    case admin.PROGRAM_VISIBILITY_ADMIN_REQUEST:
    case admin.PROGRAM_REQUIREMENTS_ADMIN_REQUEST:
    case admin.DEVICE_LOAD_GROUPS_ADMIN_REQUEST:
    case admin.PROGRAM_LOAD_GROUPS_ADMIN_REQUEST:
    case admin.ALL_PROGRAM_REQUIREMENTS_ADMIN_REQUEST:
    case admin.PROGRAM_ENROLLMENTS_ADMIN_REQUEST:
    case admin.CHARGE_FORECAST_ADMIN_REQUEST:
    case admin.USER_PLAN_UPDATE_REQUEST:
    case admin.VEHICLE_TIMELINE_REQUEST:
    case admin.ADMIN_USER_VEHICLE_REQUEST:
    case admin.ADMIN_USER_CHARGER_REQUEST:
    case admin.ADMIN_USER_ENERGY_SYSTEM_REQUEST:
    case admin.ADMIN_USER_METER_REQUEST:
    case admin.ADMIN_USER_THERMOSTAT_REQUEST:
    case admin.ADMIN_USER_INFORMATION_REQUEST:
    case admin.REWARD_PAYMENTS_ADMIN_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case admin.ELIGIBILITY_ADMIN_FAILURE:
    case admin.PROGRAM_PARTICIPATION_ADMIN_FAILURE:
    case admin.PROGRAM_VISIBILITY_ADMIN_FAILURE:
    case admin.PROGRAM_REQUIREMENTS_ADMIN_FAILURE:
    case admin.DEVICE_LOAD_GROUPS_ADMIN_FAILURE:
    case admin.PROGRAM_LOAD_GROUPS_ADMIN_FAILURE:
    case admin.ALL_PROGRAM_REQUIREMENTS_ADMIN_FAILURE:
    case admin.CHARGE_FORECAST_ADMIN_FAILURE:
    case admin.USER_PLAN_UPDATE_FAILURE:
    case admin.VEHICLE_TIMELINE_FAILURE:
    case admin.ADMIN_USER_VEHICLE_FAILURE:
    case admin.ADMIN_USER_CHARGER_FAILURE:
    case admin.ADMIN_USER_ENERGY_SYSTEM_FAILURE:
    case admin.ADMIN_USER_METER_FAILURE:
    case admin.ADMIN_USER_THERMOSTAT_FAILURE:
    case admin.ADMIN_USER_INFORMATION_FAILURE:
    case admin.PROGRAM_ENROLLMENTS_ADMIN_FAILURE:
    case admin.REWARD_PAYMENTS_ADMIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        errors: getApiErrorMessage(action.payload),
      }
    default:
      return state
  }
}

export function errors(state) {
  return state.errors
}
